import { apiRequest } from "./client";
import type { Symptom } from "../types/symptom";

export function getSymptoms(): Promise<Symptom[]> {
  return apiRequest<Symptom[]>("/symptoms");
}
